import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ActivityComponentType, useFlow } from '@stackflow/react';

declare module '@stackflow/config' {
    interface Register {
        GpsPermissionModal: {};
    }
}

const GpsPermissionModal: ActivityComponentType<'GpsPermissionModal'> = () => {
    const { pop } = useFlow();
    return (
        <AppModal deny='취소'
            confirm='허용하러 가기'
            onConfirm={pop} >
            <Text size='title' align='center'>
                위치 권한을 허용해주시면<br/>
                보다 편리한 서비스를 이용할 수 있습니다.
            </Text>
        </AppModal>
    );
};

export default GpsPermissionModal;
